module.exports = __webpack_public_path__ + "img/gift4-01-c02-y1.57cc98c7.png";